<style lang="scss">
  @import './index.scss';
</style>
<template>
  <div class="qrcode-manage">
    <h1>{{ $t('qrcodeManage.title') }}</h1>
    <div class="tooltip-box clearfix">
      <Button
        type="primary"
        shape="circle"
        icon="md-add"
        class="create-code l"
        @click="createCode">{{ $t('qrcodeManage.createCode') }}
      </Button>
      <!-- 批量创建二维码 暂不支持 -->
      <!-- <Button
        type="primary"
        shape="circle"
        icon="md-add"
        class="l"
        @click="batchCode">{{ $t('qrcodeManage.batchCode') }}
      </Button> -->
      <div class="operation-box">
        <!-- 删除 -->
        <Button
          ghost-tmp
          shape="circle"
          class="search-delete"
          :disabled="selection.length === 0"
          @click="delModal = true">
          <i class="iconfont icon-del usergroup-icon" style="position: relative;top: 1px;"></i>
          {{ $t('qrcodeManage.delete') }}
        </Button>
        <!-- 搜索框 -->
        <Input
          icon="ios-search"
          v-model="searchValue"
          :placeholder="$t('filter.search')"
          class="usergroup-search-div"
          style="width:160px"
        >
        </Input>
        <!-- 表格指标说明 -->
        <!-- <Poptip trigger="hover" class="tab-pop" placement="bottom-end">
          <span
            class="iconfont icon-help tm-icon-font hover-style tm-icon-font-portrait"
            style="margin-left:10px; top:5px; font-size:20px;"></span>
          <div slot="title">{{ $t('qrcodeManage.tablePoptip.head') }}</div>
          <div slot="content">
            <p>{{ $t('qrcodeManage.tablePoptip.fisrtLine') }}</p>
            <p v-for="item in $t('qrcodeManage.tablePoptip.explainValue')">
              <b>{{ item.title }}：</b>
              <span style="font-weight: normal;">{{ item.explain }}</span>
            <p/>
            <p>{{ $t('qrcodeManage.tablePoptip.lastLine') }}</p>
          </div>
        </Poptip> -->
      </div>
    </div>
    <!-- 表格信息 -->
    <tableMove
      class="qrcode-table"
      :change-data="tableData"
      :table-columns="tableColumns"
      :noData="noData"
      @on-change-select="onTableChangeSelect"
      :filterKey="filterKey"
      :filterValue="searchValue"
      @on-table-move-sort="sortTable"
      ></tableMove>
    <!-- 创建二维码modal框 -->
    <Modal v-model="codeShown" :mask-closable="false" class="qrcode-modal" width="660">
      <div slot="header">
        <b>{{ $t('qrcodeManage.codeModal.title') }}</b>>
        <b>{{ step }}</b>
        <b>{{ headerText }}</b>
      </div>
      <div class="qrcode-modal-content" style="padding-left: 24px;">
        <!-- 创建二维码 -->
        <div class="step-box">
          <Form :class="['code-form', currentStep === 2 ? 'form-step-two' : '']" ref="codeFormValidate" :model="inputValue" :rules="codeRuleValidate">
            <FormItem :label="$t('qrcodeManage.codeModal.codeName.title')" prop="qcodeNm">
              <Input
                v-if="currentStep === 1"
                v-model="inputValue.qcodeNm"
                :placeholder="$t('qrcodeManage.codeModal.codeName.placeholder')"
                :maxlength="128"
              ></Input>
              <span v-else class="short-block">{{ inputValue.qcodeNm }}</span>
            </FormItem>
            <!--小程序ID-->
            <FormItem :label="$t('qrcodeManage.codeModal.appId.title')" prop="appId">
              <Input
                v-if="currentStep === 1"
                v-model="inputValue.appId"
                :placeholder="$t('qrcodeManage.codeModal.appId.placeholder')"
                :disabled="!miniAppCanEdit"
              >
              </Input>
              <span v-else class="short-block">{{ inputValue.appId }}</span>
            </FormItem>
            <!--小程序密钥-->
            <FormItem :label="$t('qrcodeManage.codeModal.appSecret.title')" prop="appSecret">
              <Input
                v-if="currentStep === 1"
                v-model="inputValue.appSecret"
                :placeholder="$t('qrcodeManage.codeModal.appSecret.placeholder')"
                :type="codeSecretEye ? 'text' : 'password'"
                :disabled="!miniAppCanEdit"
              ></Input>
              <span v-else class="short-block">{{ dealCodeSecret }}</span>
              <i @click="codeSecretContral"><Icon style="top: 4px; left: 5px; position: relative; cursor: pointer;" size="20" :type="codeSecretEye ? 'md-eye' : 'md-eye-off'"></Icon></i>
            </FormItem>
            <FormItem :label="$t('qrcodeManage.codeModal.pageRoute.title')" prop="qcodePath">
              <Poptip trigger="hover" class="title-pop" placement="right" style="margin-left: -29px;">
                <span
                  class="iconfont icon-help tm-icon-font hover-style tm-icon-font-portrait"
                  style="top:3px; font-size:16px;"></span>
                <div slot="content">
                  <span>{{ $t('qrcodeManage.codeModal.pageRoute.popTip.content') }}</span>
                </div>
              </Poptip>
              <Input v-if="currentStep === 1" v-model="inputValue.qcodePath" :maxlength="128" :placeholder="$t('qrcodeManage.codeModal.pageRoute.placeholder')"></Input>
              <span v-else class="long-block">{{ inputValue.qcodePath }}</span>
            </FormItem>
            <FormItem :label="$t('qrcodeManage.codeModal.type.title')" prop="qcodeType">
              <div style="float:left; cursor:pointer;">
                <img v-if="inputValue.qcodeType === 1" @click="inputValue.qcodeType = 1" src="../../images/code-manage/small-program-checked.png"/>
                <img v-if="inputValue.qcodeType === 0 && currentStep === 1" @click="inputValue.qcodeType = 1" src="../../images/code-manage/small-program-notchecked.png"/>
                <img v-if="inputValue.qcodeType === 0" @click="inputValue.qcodeType = 0" src="../../images/code-manage/qrcode-checked.png" />
                <img v-if="inputValue.qcodeType === 1 && currentStep === 1" @click="inputValue.qcodeType = 0" src="../../images/code-manage/qrcode-notchecked.png" />
              </div>
            </FormItem>
            <FormItem :label="$t('qrcodeManage.codeModal.isChannel.title')" prop="isChannel">
              <Poptip trigger="hover" class="title-pop" placement="right" style="margin-left: -29px;">
                <span
                  class="iconfont icon-help tm-icon-font hover-style tm-icon-font-portrait"
                  style="top:3px; font-size:16px;"></span>
                <div slot="content">
                  <span>{{ $t('qrcodeManage.codeModal.isChannel.popTip.content') }}</span>
                </div>
              </Poptip>
              <RadioGroup v-if="currentStep === 1" v-model="inputValue.isChannel">
                <Radio label="no">{{ $t('qrcodeManage.codeModal.isChannel.no') }}</Radio>
                <Radio label="yes">{{ $t('qrcodeManage.codeModal.isChannel.yes') }}</Radio>
              </RadioGroup>
              <Radio v-if="currentStep === 2" v-model="channelDisabled" disabled>{{ $t(`qrcodeManage.codeModal.isChannel.${inputValue.tdChannelId ? 'yes' : 'no'}`) }}</Radio>
            </FormItem>
            <FormItem v-if="inputValue.isChannel === 'yes'" label="TDChannelID" prop="tdChannelId">
              <Input v-if="currentStep === 1" v-model="inputValue.tdChannelId" :maxlength="64" :placeholder="$t('qrcodeManage.codeModal.isChannel.placeholder')"></Input>
              <div v-else class="channel-input">
                <span>{{ inputValue.tdChannelId }}</span>
              </div>
            </FormItem>
            <!-- 自定义参数-参数 -->
            <div style="max-width: 300px; float:left;" :class="busLang === 'zh-CN'? 'zhLeft' : 'enLeft'">
              <FormItem
                class="qrcode-params-box"
                v-for="(item, index) in paramsValue"
                :key="index"
                :prop="'qcodeParams.' + index + '.params'"
                :rules="{required: true, validator: paramsReg, trigger: 'blur'}"
              >
                <div class="qrcode-params">
                  <b class="qrcode-title">{{ $t('qrcodeManage.codeModal.params.title1') }}{{index + 1}}：</b>
                  <Input v-if="currentStep === 1" v-model="item.params" :placeholder="$t('qrcodeManage.codeModal.params.placeholder1')"></Input>
                  <span class="qrcode-params-elli" v-if="currentStep === 2" :title="item.params">{{ item.params }}</span>
                </div>
              </FormItem>
            </div>
            <!-- 自定义参数-参数值 -->
            <div style="max-width: 280px; float:left;">
              <FormItem
                class="qrcode-params-box qrcode-params-value-box"
                v-for="(item, index) in paramsValue"
                :key="index"
                :prop="'qcodeParams.' + index + '.paramsValue'"
                :rules="{required: true, validator: valueReg, trigger: 'blur'}"
              >
                <div class="qrcode-value">
                  <b style="margin-left: 10px;">{{ $t('qrcodeManage.codeModal.params.title2') }}：</b>
                  <Input v-if="currentStep === 1" v-model="item.paramsValue" :placeholder="$t('qrcodeManage.codeModal.params.placeholder2')"></Input>
                  <span class="qrcode-params-elli" v-if="currentStep === 2" :title="item.paramsValue">{{ item.paramsValue }}</span>
                </div>
                <i v-if="currentStep === 1" style="margin-left:3px; cursor: pointer;" class="delete-item iconfont icon-removed" @click="deleteItem(index)"></i>
              </FormItem>
            </div>
          <Button
            class="add-params"
            :disabled="wordLimitShow"
            v-if="currentStep === 1 && paramsValue.length < 6"
            ghost-tmp @click="addCustomParams"
          >
            {{ $t('qrcodeManage.codeModal.params.buttonText') }}
          </Button>
          <div class="word-restriction" v-if="wordLimitShow">
            {{ $t('qrcodeManage.codeModal.warning.wordLimit') }}
          </div>
          </Form>
          <!-- 二维码 -->
          <div class="code-down" v-if="currentStep === 2">
            <img :src="downCodeImg"/>
            <a :href="downLoadCode">{{ $t('qrcodeManage.codeModal.downCode') }}</a>
          </div>
        </div>
      </div>
      <div slot="footer">
        <Button v-if="currentStep === 1" type="primary" @click="onCertain" :loading="createSucc">{{ cetainText }}</Button>
        <Button ghost-tmp @click="onCancel">{{ cancelText }}</Button>
      </div>
    </Modal>

    <!-- 批量创建二维码 暂不支持-->
    <!-- <Modal v-model="batchCodeShow"
      class="batch-code-modal"
      :mask-closable="false"
      width="660"
    >
      <div slot="header">
        <b>{{ $t('qrcodeManage.codeModal.title') }}</b>>
        <b>{{ $t('qrcodeManage.batchCodeModal.title') }}</b>
      </div>
      <div class="batch-code-modal-content">
        <Form ref="batchFormValidate" :model="batchInputValue" :rules="batchRuleValidate">
          <FormItem :label="$t('qrcodeManage.codeModal.appId.title')" prop="appId">
            <Input v-model="batchInputValue.appId" :placeholder="$t('qrcodeManage.codeModal.appId.placeholder')"></Input>
          </FormItem>
          <FormItem :label="$t('qrcodeManage.codeModal.appSecret.title')" prop="appSecret">
            <Input
              :type="batchSecretEye ? 'text' : 'password'"
              v-model="batchInputValue.appSecret"
              :placeholder="$t('qrcodeManage.codeModal.appSecret.placeholder')"
            >
            </Input>
            <i @click="batchSecretContral"><Icon style="top: 4px; left: 5px; position: relative; cursor: pointer;" size="20" :type="batchSecretEye ? 'md-eye' : 'md-eye-off'"></Icon></i>
          </FormItem>
          <FormItem :label="$t('qrcodeManage.batchCodeModal.createMethod')" prop="createMethod">
            <RadioGroup v-model="batchInputValue.createMethod">
              <Radio label="online">{{ $t('qrcodeManage.batchCodeModal.editOnline') }}</Radio>
              <Radio label="template">{{ $t('qrcodeManage.batchCodeModal.templateUpload') }}</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem prop="onlineValue" v-if="batchInputValue.createMethod === 'online'" :class="[batchInputValue.createMethod === 'online' ? '' : 'error-display']">
            <Input
              style="margin-left: 115px;"
              v-model="batchInputValue.onlineValue"
              type="textarea"
              :autosize="{minRows: 5,maxRows: 10}"
              :placeholder="$t('common.input')"
            ></Input>
          </FormItem>
          <FormItem v-else class="upload-box">
            <div class="upload-select">
              <p class="step-one">
                <span>Step1：{{ $t('qrcodeManage.batchCodeModal.downtemplate') }}</span>
                <img src="../../images/code-manage/xls-head.png" />
                <a style="margin-left: 20px;">{{ $t('qrcodeManage.batchCodeModal.down') }}</a>
              </p>
              <p class="step-two">
                <span>Step2：{{ $t('qrcodeManage.batchCodeModal.uploadList') }}</span>
              </p>
            </div>
            <Upload
              ref="batchCodeUpload"
              type="drag"
              :format="['xls', 'csv', 'xlsx']"
              :max-size="500"
              :before-upload="handleUpload"
              :on-success="handelSuccess"
              :on-error="handleError"
              :on-format-error="handleFormatError"
              :on-exceeded-size="handleMaxSize"
              action="//jsonplaceholder.typicode.com/posts/"
            >
              <div style="padding: 20px 0">
                <Icon type="ios-cloud-upload" size="52" style="color: #3399ff"></Icon>
                <p>{{ $t('qrcodeManage.batchCodeModal.dragValue') }}</p>
                <p>{{ $t('qrcodeManage.batchCodeModal.supportFile') }}</p>
              </div>
            </Upload>
            <div class="upload-error-tip">
              <span v-if="fileNameError">请传入后缀名为：xls csv xlsx的模板文件</span>
            </div>
            <div class="wait-upload-box">
              <span v-if="waitUploadFile">{{ $t('qrcodeManage.batchCodeModal.pendingUpload') }}{{ file.name }}</span>
            </div>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="batchCodeCertain">{{ $t('qrcodeManage.batchCodeModal.submit') }}</Button>
        <Button ghost-tmp @click="batchCodeCancel">{{ $t('qrcodeManage.batchCodeModal.cancel') }}</Button>
      </div>
    </Modal> -->

    <!-- 下载二维码modal框 -->
    <Modal v-model="downCodeShow" class="down-code-modal">
      <div class="down-code-modal-box">
        <p>
          <img :src="downCodeImg" />
          <a :href="downLoadCode">{{ $t('qrcodeManage.codeModal.downCode') }}</a>
        </p>
      </div>
      <div slot="footer"></div>
    </Modal>

    <!-- 删除分群弹窗信息 -->
    <Modal
      v-model="delModal"
      loading
      class-name="user-group-modal"
      @on-ok="deleteMulti">
      <div slot="header"></div>
      <p class="del-code-content">{{ $t('qrcodeManage.delModal') }}</p>
    </Modal>
  </div>
</template>
<script>
  import axios from 'axios';
  import bus from '../../libs/bus';
  import util from '../../libs/util';
  import tableMove from '../../components/table-move/table-move';
  import numberSeparator from '../../filters/number-separator';
  import safeHtml from '../../filters/html-formate';
  import sortData from '../../filters/sort-table-data';
  import editName from '../../components/qcode-name-edit/index';

  export default {
    data() {
      // 二维码名称验证规则
      const validateCodeName = (rule, value, callback) => {
        const reg = new RegExp('^[A-Za-z0-9\u4e00-\u9fa5]+$');
        let nameFlag = false;
        this.tableData.forEach((v) => {
          if (v.qcodeNm === value) nameFlag = true;
        });
        if (value === '') {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.codeIsNull')));
        } else if (nameFlag) {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.codeIsExisted')));
        } else if (!reg.test(value)) {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.codeError')));
        } else {
          callback();
        }
      };
      // App Id
      const validateAppId = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.appIdIsNull')));
        } else {
          callback();
        }
      };
      // App Secret
      const validateAppSecret = (rule, value, callback) => {
        if (value === '') {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.secretIsNull')));
        } else {
          callback();
        }
      };
      // TDChannelID验证规则
      const validateChannel = (rule, value, callback) => {
        const reg = new RegExp('^[0-9a-zA-Z]+$');
        if (value === '' && this.inputValue.isChannel === 'yes') {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.channelIsNull')));
        } else if (!reg.test(value)) {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.channelError')));
        } else {
          callback();
        }
      };
      // 目标页面路径验证规则
      const validatePageUrl = (rule, value, callback) => {
        const reg = new RegExp('^[0-9a-zA-Z/]+$');
        const firstWord = new RegExp('^/');
        if (value === '' && this.inputValue.isChannel === 'yes') {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.qcodePathIsNull')));
        } else if (firstWord.test(value)) {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.qcodePathFirstLimt')));
        } else if (!reg.test(value)) {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.qcodeError')));
        } else {
          callback();
        }
      };
      // 参数验证规则
      const validateParams = (rule, value, callback) => {
        const reg = new RegExp('^[a-zA-Z]+$');
        // 自定义参数索引 以下为判断参数是否重复
        const index = rule.field.split('.')[1];
        const qcodeParams = JSON.parse(JSON.stringify(this.inputValue.qcodeParams));
        const haveParams = qcodeParams.map(v => v.params);
        haveParams.splice(index, 1);

        if (value === '') {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.paramsIsNull')));
        } else if (!reg.test(value) || value === 'TDChannelID' || value === 't') {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.paramsError')));
        } else if (haveParams.indexOf(value) > -1) {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.paramsRepeat')));
        } else {
          callback();
        }
      };
      // 参数值验证规则
      const validateValue = (rule, value, callback) => {
        const reg = new RegExp('^[0-9a-zA-Z]+$');
        if (value === '') {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.valueIsNull')));
        } else if (!reg.test(value)) {
          callback(new Error(this.$t('qrcodeManage.codeModal.warning.valueError')));
        } else {
          callback();
        }
      };
      return {
        searchValue: '', // 输入框输入值
        filterKey: ['qcodeNm', 'appId'], // 输入框按此字段搜索
        selection: [], // 表格选中行数据
        tableData: [], // 表格数据
        noData: this.$t('common.loading'),
        delModal: false,
        downCodeShow: false,
        downCodeImg: '', // 点击table下载按钮获取当前行二维码url
        // modal相关
        currentStep: 1, // 当前是第几步操作
        createSucc: false, // 是否创建成功二维码 控制button loading
        codeShown: false, // 控制创建二维码modal框显示
        batchCodeShow: false, // 控制批量创建modal框提示
        // 创建二维码信息： 输入框、单元框绑定值
        inputValue: {
          qcodeNm: '',
          appId: '',
          appSecret: '',
          qcodePath: '',
          qcodeType: 1, // 0标识二维码 1标识小程序码
          isChannel: 'no',
          tdChannelId: '',
          qcodeParams: [],
        },
        mapQcodeNm: '', // 创建第一步的二维码名称
        channelDisabled: true,
        codeSecretEye: false,
        // 创建二维码表单规则相关
        codeRuleValidate: {
          qcodeNm: [{
            required: true,
            validator: validateCodeName,
            trigger: 'blur',
          }],
          appId: [{
            required: true,
            validator: validateAppId,
            trigger: 'blur',
          }],
          appSecret: [{
            required: true,
            validator: validateAppSecret,
            trigger: 'blur',
          }],
          qcodePath: [{
            required: true,
            validator: validatePageUrl,
            trigger: 'blur',
          }],
          qcodeType: [{
            required: true,
          }],
          tdChannelId: [{
            required: true,
            validator: validateChannel,
            trigger: 'blur',
          }],
        },
        paramsReg: validateParams, // 参数验证规则
        valueReg: validateValue, // 参数值验证规则
        // 批量创建二维码表单对象
        batchInputValue: {
          appId: '',
          appSecret: '',
          createMethod: 'online',
          onlineValue: '', // 在线批量编辑文本域内容
        },
        batchSecretEye: true, // 批量创建APP Secret明文密文切换
        // 批量创建二维码验证规则
        batchRuleValidate: {
          appId: [{
            required: true,
            message: this.$t('qrcodeManage.codeModal.warning.appIdIsNull'),
            trigger: 'blur',
          }],
          appSecret: [{
            required: true,
            message: this.$t('qrcodeManage.codeModal.warning.secretIsNull'),
            trigger: 'blur',
          }],
          onlineValue: [{
            required: true,
            message: '请输入在线编辑内容',
            trigger: 'blur',
          }],
        },
        file: null, // 要上传的文件
        fileNameError: false, // 控制"上传文件格式验证"的提示语
        waitUploadFile: false, // 待上传文件提示语

        // 用于取消请求
        source: axios.CancelToken.source(),
        miniAppCanEdit: true,
      };
    },
    components: {
      tableMove,
      safeHtml,
      editName,
    },
    computed: {
      // 创建二维码modal框相关
      step() {
        const index = this.currentStep;
        return this.$t(`qrcodeManage.codeModal.step${index}.step`);
      },
      headerText() {
        const index = this.currentStep;
        return this.$t(`qrcodeManage.codeModal.step${index}.headerText`);
      },
      cetainText() {
        const index = this.currentStep;
        return this.$t(`qrcodeManage.codeModal.step${index}.certain`);
      },
      cancelText() {
        const index = this.currentStep;
        return this.$t(`qrcodeManage.codeModal.step${index}.cancel`);
      },
      // 单个创建二维码App Secret显示明文or密文
      dealCodeSecret() {
        if (this.codeSecretEye) {
          return this.inputValue.appSecret;
        }
        return this.inputValue.appSecret.replace(/./g, '*');
      },
      // 参数数组
      paramsValue() {
        if (this.currentStep !== 1) {
          return this.inputValue.qcodeParams.filter(v => v.params);
        }
        return this.inputValue.qcodeParams;
      },
      // 最终拼接成发送的url
      postUrl() {
        let url = '';
        url = this.inputValue.qcodePath;
        const channelUrl = this.inputValue.isChannel === 'yes' ? {
          params: 'TDChannelId',
          paramsValue: this.inputValue.tdChannelId,
        } : {
          params: '',
          paramsValue: '',
        };
        const qcodeType = {
          params: 't',
          paramsValue: this.inputValue.qcodeType,
        };
        // 自定义参数 按照首字母排序
        let qcodeParams = JSON.parse(JSON.stringify(this.inputValue.qcodeParams));
        qcodeParams.push(channelUrl);
        qcodeParams.push(qcodeType);
        qcodeParams = qcodeParams.sort((a, b) => a.params > b.params);

        let parmasUrl = qcodeParams.length ? qcodeParams
        .filter(item => item.params && (item.paramsValue || item.paramsValue === 0))
        .map(v => `${v.params}=${v.paramsValue}`).join('&') : '';
        parmasUrl = parmasUrl.length ? `?${parmasUrl}` : '';
        url = `${url}${parmasUrl}`;
        return url;
      },
      // 控制message提示 为true表示长度超过128 否则为false
      wordLimitShow() {
        return this.postUrl.length > 128;
      },
      // 拼接下载图片URL
      downLoadCode() {
        const url = `${window.location.origin}/app/rest/miniApp/qcode/download/${bus.token}?json={"qcodeImgUrl":"${this.downCodeImg}"}`;
        return encodeURI(url);
      },
      // 表格表头
      tableColumns() {
        const self = this;
        const list = [{
          type: 'selection',
          width: 60,
          align: 'center',
        }, {
          key: 'qcodeNm',
          width: 250,
          title: self.$t('qrcodeManage.table.qcodeNm'),
          // render(h, params) {
          //   return h('div', [
          //     h('p', {
          //       class: {
          //         textEllipsis: true,
          //       },
          //       domProps: {
          //         title: safeHtml(params.row.qcodeNm),
          //       },
          //     }, safeHtml(params.row.qcodeNm)),
          //   ]);
          // },
          render(h, params) {
            return h(editName, {
              props: {
                name: params.row.qcodeNm,
                qcodeId: params.row.qcodeId,
                tableData: self.tableData,
              },
              on: {
                'on-change-edit': self.setSiblingsEdit,
                'on-change-name-succ': self.updateTableData,
              },
            });
          },
        }, {
          key: 'qcodeId',
          width: 160,
          title: self.$t('qrcodeManage.table.qcodeId'),
          align: 'left',
        }, {
          key: 'appId',
          title: self.$t('qrcodeManage.table.appId'),
          align: 'left',
        }, {
          key: 'qcodePath',
          title: self.$t('qrcodeManage.table.qcodePath'),
          align: 'left',
        }, {
          key: 'tdChannelId',
          title: self.$t('qrcodeManage.table.tdChannelId'),
          align: 'left',
          render(h, params) {
            const value = params.row.tdChannelId ? params.row.tdChannelId : self.$t('qrcodeManage.table.null');
            return h('span', {
              class: {
                textEllipsis: true,
              },
            }, safeHtml(value));
          },
        }, {
          key: 'qcodeParams',
          title: self.$t('qrcodeManage.table.qcodeParams'),
          align: 'left',
          render(h, params) {
            const paramsArr = JSON.parse(params.row.qcodeParams);
            let value = paramsArr.length ? paramsArr.map(v => `${v.params}：${v.paramsValue}`) : self.$t('qrcodeManage.table.null');
            // const value = params.row.qcodeParams;
            value = typeof (value) === 'string' ? value : value.join(';');
            return h('div', [
              h('p', {
                class: {
                  'line-clamp-test-ellipsis': true,
                },
                domProps: {
                  title: safeHtml(value),
                },
              }, safeHtml(value)),
            ]);
          },
        }, {
          key: 'qcodeType',
          title: self.$t('qrcodeManage.table.qcodeType'),
          align: 'center',
          render(h, params) {
            // qcodeType为1标识小程序码 0标识二维码
            const type = params.row.qcodeType * 1 === 1 ?
            self.$t('qrcodeManage.table.qcodeType2') : self.$t('qrcodeManage.table.qcodeType1');
            return h('span', type);
          },
        }, {
          key: 'createTime',
          title: self.$t('qrcodeManage.table.createTime'),
          align: 'center',
          // sortable: 'custom',
        }, {
          key: 'operation',
          title: self.$t('qrcodeManage.table.operation'),
          align: 'center',
          render(h, params) {
            return h('div', [
              h('span', {
                class: 'iconfont icon-download tm-icon-font down-button',
                on: {
                  click: () => {
                    self.downCodeImg = params.row.qcodeImgUrl;
                    self.downCodeShow = true;
                    // self.downLoadCode(params.row.qcodeImgUrl);
                  },
                },
              }),
              // 编辑暂时去除
              // h('i', {
              //   class: 'iconfont icon-edit tm-icon-font tm-icon-font-operation',
              //   on: {
              //     click: () => {
              //       self.editCode(params.row);
              //     },
              //   },
              // }),
            ]);
          },
        }];
        return list;
      },
      busLang() {
        return bus.lang;
      },
    },
    filters: {
      numberSeparator,
    },
    mounted() {
      bus.$on('on-app-change', () => {
        this.init();
      });
      bus.$on('on-platform-change', () => {
        this.init();
      });
      if (!bus.productInfo.productid) {
        return;
      }
      this.init();
    },
    beforeDestroy() {
      bus.$off('on-app-change');
      bus.$off('on-platform-change');
    },
    methods: {
      init() {
        this.tableData = [];
        this.noData = this.$t('common.loading');
        this.getTableData();
      },
      // 获取表格数据并渲染
      getTableData() {
        const params = {
          productId: bus.productid,
        };
        util.ajax.post('/app/rest/miniApp/qcode/query', params, {
          cancelToken: this.source.token,
        }).then((res) => {
          this.tableData = JSON.parse(JSON.stringify(res));
          if (!res.length) this.noData = this.$t('common.nodata');
        }).catch((error) => {
          if (error.response) {
            this.$Message.error({
              content: this.$t('common.errorTip'),
              duration: 3,
            });
          }
        });
      },
      /**
       * 自定义排序
       * @param  {[Object]} obj [点击排序列内容]
       * @param {String} name [table-move 绑定的refs 表格数据前缀 例：ref为pageTable，则此表格绑定数据为pageTableData]
       */
      sortTable(obj, tableData) {
        const data = tableData;
        const list = sortData(obj, data);
        this.pageTableData = list;
      },
      // 创建二维码
      createCode() {
        this.clearInfo();
        // 请求产品信息，获取小程序ID和小程序密钥
        this.getMiniAppInfo();
        this.inputValue.tdChannelId = '';
        this.inputValue.qcodeParams = [];
        this.currentStep = 1;
        this.codeShown = true;
      },
      getMiniAppInfo() {
        const self = this;
        const oParams = [
          `productid=${bus.setEncode(bus.productInfo.productid)}`,
          `platformid=${bus.setEncode(bus.platform.toString())}`,
          `platforms=${bus.platform.toString()}`,
          'servertype=3',
        ];
        const params = oParams.join('&');

        util.ajax.post('/app/servlet/ProductServlet', params)
          .then((res) => {
            if (res.miniAppId && res.miniAppSecret) {
              self.miniAppCanEdit = false;
              self.inputValue.appId = res.miniAppId;
              self.inputValue.appSecret = res.miniAppSecret;
            } else {
              self.miniAppCanEdit = true;
            }
          });
      },
      // 批量创建二维码
      batchCode() {
        this.batchCodeShow = true;
      },
      // 删除二维码
      deleteMulti() {
        const qcodeIdArr = this.selection.map(value => value.qcodeId);
        const params = {
          productId: bus.productid,
          qcodeIds: qcodeIdArr,
        };
        util.ajax.post('/app/rest/miniApp/qcode/delete', params, {
          cancelToken: this.source.token,
        }).then(() => {
          this.delModal = false;
          // this.getTableData();
          this.selection = [];
          this.tableData = this.tableData.filter(v => qcodeIdArr.indexOf(v.qcodeId) < 0);
        }).catch((error) => {
          if (error.response) {
            this.$Message.error({
              content: this.$t('common.delFailed'),
              duration: 3,
            });
          }
        });
      },
      // 清空信息
      clearInfo() {
        this.createSucc = false;
        this.$refs.codeFormValidate.resetFields();
        this.inputValue.isChannel = 'no';
      },
      onTableChangeSelect(select) {
        this.selection = select;
      },
      // 编辑二维码
      editCode(row) {
        this.$refs.codeFormValidate.resetFields();
        this.downCodeImg = row.qcodeImgUrl;
        const data = JSON.parse(JSON.stringify(row));
        data.qcodeParams = JSON.parse(data.qcodeParams);
        data.isChannel = row.tdChannelId ? 'yes' : 'no';
        this.inputValue = data;
        this.mapQcodeNm = this.inputValue.qcodeNm;
        this.currentStep = 3;
        this.codeShown = true;
        this.createSucc = false;
      },
      // 创建二维码接口
      creteCodeData() {
        this.createSucc = true;
        const params = {
          productId: bus.productid,
          platformId: bus.platform.toString(),
          qcodeUrl: this.postUrl,
          qcodeNm: this.inputValue.qcodeNm,
          appId: this.inputValue.appId,
          appSecret: this.inputValue.appSecret,
          qcodePath: this.inputValue.qcodePath,
          qcodeType: this.inputValue.qcodeType,
          isChannel: this.inputValue.isChannel,
          tdChannelId: this.inputValue.tdChannelId,
          qcodeParams: JSON.stringify(this.inputValue.qcodeParams),
          developerId: bus.developerid,
        };

        // 判断生产环境
        const $ = {};
        $.ajax = axios.create({
          baseURL: util.baseURL,
          withCredentials: true,
          timeout: 60000,
        });
        $.ajax.post(`app/rest/miniApp/qcode/create/${bus.token}`, params, {
          cancelToken: this.source.token,
        }).then((res) => {
          if (res.data.code !== 200) {
            this.$Message.error({
              content: this.$t(`qrcodeManage.codeModal.code${res.data.code}`),
              duration: 5,
            });
            this.createSucc = false;
            return;
          }
          this.inputValue.qcodeId = res.data.result.qcodeId;
          this.downCodeImg = res.data.result.qcodeImgUrl;
          this.createSucc = false;
          this.currentStep += 1;
          this.getTableData();
        }).catch((error) => {
          if (error.response) {
            this.$Message.error({
              content: this.$t('common.delFailed'),
              duration: 5,
            });
          }
        });
      },
      // 只能单个出现 “修改名称组件”
      setSiblingsEdit(id) {
        bus.$emit('on-close-edit', id);
      },
      /** 更改二维码名称回调成功后更新tableData
       * @param {id} [String] qcodeId 标识二维码唯一id
       * @param {name} [String] 修改后的二维码名称
       */
      updateTableData(id, name) {
        this.tableData.forEach((v, i) => {
          if (v.qcodeId === id) this.tableData[i].qcodeNm = name;
        });
      },
      // 单个创建二维码确定按钮
      onCertain() {
        /* 编辑暂时去除 创建改为两步 暂时注释此代码 */
        // if (this.currentStep === 3) {
        //   this.$refs.codeFormValidate.validate((valid) => {
        //     if (valid) {
        //       if (this.mapQcodeNm !== this.inputValue.qcodeNm) { // 若没改变二维码名称则不送请求
        //         this.updateCodeData();
        //       } else {
        //         this.codeShown = false;
        //       }
        //     }
        //   });
        // } else if (this.currentStep < 3) {
        //   this.$refs.codeFormValidate.validate((valid) => {
        //     if (valid && !this.wordLimitShow) {
        //       if (this.currentStep === 1) {
        //         this.mapQcodeNm = this.inputValue.qcodeNm;
        //         this.creteCodeData();
        //       } else if (this.currentStep === 2) {
        //         this.currentStep += 1;
        //       }
        //     }
        //   });
        // }
        if (this.currentStep === 2) {
          this.codeShown = false;
        } else {
          this.$refs.codeFormValidate.validate((valid) => {
            if (valid && !this.wordLimitShow) {
              this.mapQcodeNm = this.inputValue.qcodeNm;
              this.creteCodeData();
            }
          });
        }
      },
      // 单个创建二维码取消按钮
      onCancel() {
        this.codeShown = false;
      },
      // 单个创建二维码 控制切换App Secret明文、密文
      codeSecretContral() {
        if (this.miniAppCanEdit) {
          this.codeSecretEye = !this.codeSecretEye;
        }
      },
      // 增加自定义参数
      addCustomParams() {
        const tmp = {
          params: '',
          paramsValue: '',
        };
        this.inputValue.qcodeParams.push(tmp);
      },
      // 删除参数目标
      deleteItem(index) {
        this.inputValue.qcodeParams.splice(index, 1);
        const len = this.paramsValue.length;
        for (let i = 0; i < len; i += 1) {
          this.$refs.codeFormValidate.validateField(`qcodeParams.${i}.params`);
          this.$refs.codeFormValidate.validateField(`qcodeParams.${i}.paramsValue`);
        }
      },
      /* 以下为批量创简二维码 暂不支持 */
      // 批量创建二维码提交按钮
      /* batchCodeCertain() {
        this.$refs.batchFormValidate.validate((valid) => {
          if (valid) {
            // ajax
            this.$refs.batchCodeUpload.post(this.file);
          }
        });
      },
      // 批量创建取消按钮
      batchCodeCancel() {
        this.batchCodeShow = false;
      },
      // 控制批量创建二维码的APP Secret明文密文
      batchSecretContral() {
        this.batchSecretEye = !this.batchSecretEye;
      },
      // 上传文件之前的钩子
      handleUpload(file) {
        const reg = /\.(xls|csv|xlsx)(\?.*)?$/;
        this.file = file;
        this.fileNameError = false;
        this.waitUploadFile = true;
        if (!reg.test(file.name)) {
          this.file = null;
          this.fileNameError = true;
          this.waitUploadFile = false;
        }
        return false;
      },
      // 文件上传成功
      handelSuccess(response, file, fileList) {
        console.log('----succ', response, file, fileList);
        this.waitUploadFile = false;
        this.$Message.success({
          content: '上传成功',
          duration: 5,
        });
      },
      // 文件上传失败
      handleError(error, file, fileList) {
        console.log('----error', error, file, fileList);
        this.$Message.error({
          content: '上传失败，请重试',
          duration: 5,
        });
      },
      // 文件格式验证失败
      handleFormatError(file, fileList) {
        console.log('---format-error', file, fileList);
        this.$Message.error({
          content: '文件格式不正确',
          duration: 5,
        });
      },
      // 文件超出指定大小
      handleMaxSize(file, fileList) {
        console.log('---max-size-error', file, fileList);
        this.$Message.warning({
          content: '超出文件大小限制',
          duration: 5,
        });
      }, */
    },
    watch: {
      wordLimitShow() {
        if (this.wordLimitShow) {
          this.$Message.warning({
            content: this.$t('qrcodeManage.codeModal.warning.wordLimit'),
            top: 50,
            duration: 10,
          });
        }
      },
    },
  };
</script>
